//BASE URL
export const BASE_URL = 'https://api.avnain.com';


//admin
export const ADMIN_LOGIN = "/api/v1/admin/signin";
export const ADMIN_REGISTER = "/api/v1/admin/signup";

// product type
export const POST_type = "/api/v1/type/createtype";
export const GET_type = "/api/v1/type/featchall";
export const DELETE_type = "/api/v1/type/deletetype/";
export const PUT_type = "/api/v1/type/updatatype/";


// product
export const POST_product = "/api/v1/product/createproduct";
export const GET_product = "/api/v1/product/featchall";
export const DELETE_product = "/api/v1/product/deleteproduct/";
export const PUT_product = "/api/v1/product/updataproduct/";

//blog
export const POST_blog = "/api/v1/Blog/createblog";
export const GET_blog = "/api/v1/Blog/featchall";
export const DELETE_blog = "/api/v1/Blog/deleteblog/";
export const PUT_blog = "/api/v1/Blog/updatablog/";

//contactlist
export const POST_contactlist = "/api/v1/contactlist/createcontactlist";
export const GET_contactlist = "/api/v1/contactlist/featchall";
export const DELETE_contactlist = "/api/v1/contactlist/deletelist/";
export const PUT_contactlist = "/api/v1/contactlist/updatalist/";

//feedback
export const GET_FEEDBACK = "/api/v1/contact/featchall"





